// src/utils/roles.ts
export const ROLES = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    DEVELOPER: 'developer',
    MAINTAINER: 'maintainer',
    ACCOUNT_MANAGER: 'account_manager',
    CLIENT: 'client',
  };
  
  export const PERMISSIONS = {
    VIEW_DASHBOARD: 'view_dashboard',
    MANAGE_USERS: 'manage_users',
    MANAGE_TEMPLATES: 'manage_templates',
    MANAGE_PAGES: 'manage_pages',
    MANAGE_ASSETS: 'manage_assets',
    VIEW_ANALYTICS: 'view_analytics',
    MANAGE_SETTINGS: 'manage_settings',
    MANAGE_ROLES: 'manage_roles',
    GENERIC_PERMISSION: 'generic_permission',
    SUBSCRIPTION_MANAGEMENT: 'subscription_management',
  };
  
  export const ROLE_PERMISSIONS = {
    [ROLES.SUPER_ADMIN]: Object.values(PERMISSIONS),
    [ROLES.ADMIN]: [
      PERMISSIONS.VIEW_DASHBOARD,
      PERMISSIONS.MANAGE_USERS,
      PERMISSIONS.MANAGE_TEMPLATES,
      PERMISSIONS.MANAGE_PAGES,
      PERMISSIONS.MANAGE_ASSETS,
      PERMISSIONS.VIEW_ANALYTICS,
      PERMISSIONS.MANAGE_SETTINGS,
      PERMISSIONS.GENERIC_PERMISSION,
      PERMISSIONS.SUBSCRIPTION_MANAGEMENT,
    ],
    [ROLES.DEVELOPER]: [
      PERMISSIONS.MANAGE_TEMPLATES,
      PERMISSIONS.MANAGE_PAGES,
      PERMISSIONS.MANAGE_ASSETS,
      PERMISSIONS.GENERIC_PERMISSION,
    ],
    [ROLES.MAINTAINER]: [
      PERMISSIONS.MANAGE_PAGES,
      PERMISSIONS.MANAGE_ASSETS,
      PERMISSIONS.GENERIC_PERMISSION,
    ],
    [ROLES.ACCOUNT_MANAGER]: [
      PERMISSIONS.VIEW_ANALYTICS,
      PERMISSIONS.MANAGE_PAGES,
      PERMISSIONS.GENERIC_PERMISSION,
      PERMISSIONS.SUBSCRIPTION_MANAGEMENT,
    ],
    [ROLES.CLIENT]: [
      PERMISSIONS.VIEW_ANALYTICS,
      PERMISSIONS.GENERIC_PERMISSION,
    ],
  };
  
  export const hasPermission = (userRole: string, permission: string): boolean => {
    return ROLE_PERMISSIONS[userRole]?.includes(permission) || false;
  };